module.exports = __webpack_public_path__ + "static/media/website-banner.c870eea6.jpg";